import Query from '../../core/query/query';
export class ServiceLevelQuery extends Query {

}
